import LayerAdminService from "./LayerAdminService";

export default class OSHighwaysService extends LayerAdminService {
  private _lbBaseUrl = process.env.REACT_APP_LB_URL;

  public async Import(file: File): Promise<any> {
    const formData = new FormData();
    formData.append("uploadedFile", file);
    return this._client
      .post<any>(`${this._endpoint}/os:highways`, formData, {
        baseURL: this._lbBaseUrl,
        timeout: 0,
      })
      .then((response) => {
        return response.data;
      });
  }

  public async Revert(): Promise<any> {
    return this._client
      .delete<any>(`${this._endpoint}/os:highways/latest`)
      .then((response) => {
        return response.data;
      });
  }

  public async Approve(versionId: number): Promise<any> {
    return this._client
      .patch<any>(
        `${this._endpoint}/OS:Highways/Approve?versionId=${versionId}`,
      )
      .then((response) => {
        return response.data;
      })
      .then(() => {});
  }

  public async Reject(versionId: number): Promise<any> {
    return this._client
      .patch<any>(`${this._endpoint}/OS:Highways/Reject?versionId=${versionId}`)
      .then((response) => {
        return response.data;
      });
  }
}
